// ©2024 Austin App House. All rights reserved.
// Imported first in index.js so errors during app start are captured too.
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://eb0b0c5541f83f2f6597ef3135209f37@o4511904001622016.ingest.us.sentry.io/4512210482823168',
  // Deploy builds set REACT_APP_MODE (production on master, development on develop).
  environment: process.env.REACT_APP_MODE === 'production' ? 'production' : 'development',
  // Local `npm start` builds stay out of Sentry.
  enabled: process.env.NODE_ENV === 'production',
});
